export default __webpack_public_path__ + "static/media/yearbook-icon.76cee395.svg";